// Shared by the endpoint, the admin routes, and the admin UI. They live here rather than in
// common-backend because the admin panel is a client component, and importing common-backend from
// anything the browser bundle reaches pulls TypeORM and OpenTelemetry in with it.

export const BILLING_PLAN_TYPES = ['BILLED_UPFRONT', 'MONTHLY'] as const
export type BillingPlanType = (typeof BILLING_PLAN_TYPES)[number]

export const APPLE_IMAGE_SIZES = ['FULL_SIZE', 'BULLET_POINT'] as const
export type AppleImageSize = (typeof APPLE_IMAGE_SIZES)[number]

export const MAX_BULLET_POINTS = 5

// Apple splits five of its languages across storefronts — English four ways, Chinese by script —
// so a sheet written in one language still binds to several shortcodes.
export function appleLocalesForLanguage(language: string): string[] {
  return APPLE_LOCALES.filter((locale) => locale === language || locale.startsWith(`${language}-`))
}

export function appleLanguages(): string[] {
  return [...new Set(APPLE_LOCALES.map((locale) => locale.split('-')[0] ?? locale))]
}

// Use this if we don't have a matching locale in the database
export const ALL_LOCALES = ''

// The closed set App Store Connect accepts, copied by hand from
// https://developer.apple.com/documentation/appstoreconnectapi/managing-metadata-in-your-app-by-using-locale-shortcodes
// A locale outside it saves cleanly and then matches nothing Apple sends.
export const APPLE_LOCALES = [
  'ar-SA',
  'bn-BD',
  'ca',
  'cs',
  'da',
  'de-DE',
  'el',
  'en-AU',
  'en-CA',
  'en-GB',
  'en-US',
  'es-ES',
  'es-MX',
  'fi',
  'fr-CA',
  'fr-FR',
  'gu-IN',
  'he',
  'hi',
  'hr',
  'hu',
  'id',
  'it',
  'ja',
  'kn-IN',
  'ko',
  'ml-IN',
  'mr-IN',
  'ms',
  'nl-NL',
  'no',
  'or-IN',
  'pa-IN',
  'pl',
  'pt-BR',
  'pt-PT',
  'ro',
  'ru',
  'sk',
  'sl-SI',
  'sv',
  'ta-IN',
  'te-IN',
  'th',
  'tr',
  'uk',
  'ur-PK',
  'vi',
  'zh-Hans',
  'zh-Hant'
] as const
